export default __webpack_public_path__ + "static/media/home_en.f4a7c04e.md";